<template>
    <div class="page-container">
        <div class="page-header">
            <div class="header-top">
                <div class="top-title" @click="searchFlag = false">
                    快享商城
                </div>
                <div>
                    <a-input-search
                        v-model:value="searchVal"
                        placeholder="搜索"
                        style="width: 300px; border-radius: 8px"
                        allow-clear
                        @search="onSearch"
                        @change="searchChange"
                    />
                </div>
            </div>
            <div class="header-bottom">
                <div class="header-bottom-left">
                    <div class="header-class">
                        <div
                            :class="{
                                'bottom-item': true,
                                'bottom-item-active': item.id === activeClassId,
                            }"
                            @click="handleClassClick(item)"
                            v-for="item in state.classTypes || []"
                            :key="item.id"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="header-label">
                        <div
                            :class="{
                                'bottom-item': true,
                                'bottom-item-active': item.id === activeKey,
                            }"
                            @click="scrollToSection(item)"
                            v-for="item in nameToLabelMap[activeClass] || []"
                            :key="item.id"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div class="header-bottom-right">
                    <button class="btn" @click="addComponentClick">创建</button>
                    <button class="btn" v-if="false">审核</button>
                </div>
            </div>
            <template v-if="searchFlag">
                <div class="page-content">
                    <MarketCards
                        :queryType="tagName"
                        :searchStr="searchStr"
                        :classType="className"
                        :load-more="true"
                        @openEditComponent="editComponent"
                        @openDetailComponent="handleClick"
                    />
                </div>
            </template>
            <template v-else>
                <!-- 首页 -->
                <div
                    class="page-content"
                    v-for="idx in nameToLabelMap[activeClass]"
                    :key="idx.id"
                >
                    <div
                        class="content-title"
                        @click="changeTags(idx.id, idx.name)"
                        :id="idx.sectionId"
                        :style="{ 'scroll-margin-top': '100px' }"
                    >
                        {{ idx.name }}
                        <i>
                            <RightOutlined />
                        </i>
                    </div>
                    <div class="content-cards">
                        <div
                            class="cards-item"
                            v-for="item in state.allData?.dataTable[
                                activeClass
                            ][idx.name] || []"
                            :key="item.Id"
                        >
                            <div class="item-left" @click="handleClick(item)">
                                <img :src="item.appIcon" alt="" />
                            </div>
                            <div class="item-right">
                                <div class="__header">
                                    <div class="__local">
                                        {{
                                            item.isRemote == "1"
                                                ? "Host"
                                                : "Local"
                                        }}
                                    </div>
                                    <div class="__status">
                                        {{ item.statusName }}
                                    </div>
                                </div>

                                <div class="__title" @click="handleClick(item)">
                                    {{ item.appName }}
                                </div>
                                <div
                                    class="__content"
                                    @click="handleClick(item)"
                                >
                                    {{ item.appDesc }}
                                </div>
                                <div class="__label">{{ activeClass }}</div>
                                <div class="__bottom">
                                    <div>@{{ item.createMan }}</div>
                                    <div>
                                        <svg
                                            t="1756362374635"
                                            class="icon"
                                            viewBox="0 0 1092 1024"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            p-id="17931"
                                            width="10"
                                            height="10"
                                        >
                                            <path
                                                d="M324.539733 0v392.260267H68.266667l468.992 406.869333 486.536533-406.869333H785.066667V0H324.539733zM0 992.6656h1092.266667V887.466667H0v105.198933z"
                                                fill="#99B4D6"
                                                p-id="17932"
                                            ></path>
                                        </svg>

                                        {{ item.downloadTimes }}
                                    </div>
                                    <div>
                                        <svg
                                            t="1756362009717"
                                            class="icon"
                                            viewBox="0 0 1024 1024"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            p-id="7688"
                                            width="10"
                                            height="10"
                                        >
                                            <path
                                                d="M928.445934 408.299453H664.597495C766.889116 29.804198 594.187335 10.458564 594.187335 10.458564c-73.155759 0-58.000776 58.036902-63.510037 67.736814 0 185.07504-196.183877 330.104075-196.183878 330.104075v524.860963c0 51.805116 70.46435 70.446287 98.100971 70.446287h396.431963c37.336532 0 67.700688-98.064844 67.700688-98.064844 98.064844-334.312789 98.064844-433.714306 98.064844-433.714306-0.018063-69.055424-66.345952-63.5281-66.345952-63.5281zM226.204833 408.462022H68.260646c-32.62205 0-33.163944 32.044029-33.163945 32.044028l32.603987 529.467067c0 33.633586 33.633586 33.633586 33.633586 33.633586h136.792239c28.503651 0 28.232704-22.271865 28.232704-22.271864V448.562216c0-40.660152-40.154383-40.100194-40.154384-40.100194z"
                                                fill="#FFA800"
                                                p-id="7689"
                                            ></path>
                                        </svg>
                                        {{ item.likeTimes }}
                                    </div>
                                    <div>
                                        <svg
                                            t="1756362943296"
                                            class="icon"
                                            viewBox="0 0 1024 1024"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            p-id="19962"
                                            width="10"
                                            height="10"
                                        >
                                            <path
                                                d="M512.092526 889.548815l-250.07132 127.559047a62.170407 62.170407 0 0 1-82.723213-24.941305 57.781908 57.781908 0 0 1-6.143899-37.667952l47.761501-270.258418L18.605776 492.901617A58.513324 58.513324 0 0 1 17.508651 408.861854a61.950982 61.950982 0 0 1 35.034853-17.334572l279.620549-39.423352 125.072231-245.829105a62.097266 62.097266 0 0 1 81.991796-26.98927 60.341866 60.341866 0 0 1 27.793829 26.98927l125.072231 245.829105 279.620549 39.423352a59.756733 59.756733 0 0 1 51.784292 67.363465 58.513324 58.513324 0 0 1-17.846564 34.01087l-202.309819 191.411712 47.761501 270.258417a59.610449 59.610449 0 0 1-49.95575 68.606873 62.828682 62.828682 0 0 1-38.83822-5.997616z"
                                                fill="#FFCA28"
                                                p-id="19963"
                                            ></path></svg
                                        >收藏
                                    </div>
                                    <div>
                                        <svg
                                            t="1756363354746"
                                            class="icon"
                                            viewBox="0 0 1024 1024"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            p-id="31030"
                                            width="10"
                                            height="10"
                                        >
                                            <path
                                                d="M11.906977 686.144703C11.906977 815.040274 116.401033 919.527686 245.282364 919.527686 336.61059 919.527686 415.644553 867.07512 453.998997 790.654166L678.775475 830.246531 678.69434 836.171752C678.69434 928.249761 753.334677 1002.872594 845.396182 1002.872594 937.453687 1002.872594 1012.093023 928.249761 1012.093023 836.171752 1012.093023 744.092767 937.453687 669.475911 845.396182 669.475911 778.632502 669.475911 721.072771 708.661581 694.439626 765.323431L475.158671 726.724775C477.472673 713.56004 478.661727 699.982586 478.661727 686.144703 478.661727 625.213488 455.296238 569.751719 417.078034 528.208991L619.848371 325.417817C638.146084 332.321744 657.974439 336.079229 678.69434 336.079229 770.756846 336.079229 845.396182 261.456372 845.396182 169.383388 845.396182 77.310404 770.756846 2.686547 678.69434 2.686547 586.637836 2.686547 511.9985 77.310404 511.9985 169.383388 511.9985 216.140133 531.256868 258.382062 562.251562 288.660361L365.047879 485.862876C330.029199 464.866614 289.08725 452.76572 245.282364 452.76572 116.401033 452.771721 11.906977 557.249131 11.906977 686.144703L11.906977 686.144703 11.906977 686.144703Z"
                                                fill="#7A7A7A"
                                                p-id="31031"
                                            ></path></svg
                                        >分享
                                    </div>
                                    <button
                                        class="button"
                                        @click="editComponent(item)"
                                        v-if="
                                            proxy.$store.state.userID ==
                                                item.creatorUID ||
                                            proxy.$store.state.isAdmin == '1'
                                        "
                                    >
                                        修改
                                    </button>
                                    <button
                                        class="button-delete"
                                        @click="delComponent(item)"
                                        v-if="
                                            proxy.$store.state.userID ==
                                                item.creatorUID &&
                                            item.status == '0'
                                        "
                                    >
                                        删除
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
    <addComponent
        ref="addComponentRef"
        @flashIndex="getComponentsListApi"
    ></addComponent>
    <appDetails ref="appDetailsRef"></appDetails>
    <auditComponent ref="auditComponentRef"></auditComponent>
</template>

<script setup>
import {
    reactive,
    ref,
    onMounted,
    onUnmounted,
    watch,
    getCurrentInstance,
    computed,
    onActivated,
} from "vue";
import {
    UserOutlined,
    CommentOutlined,
    DownOutlined,
    RightOutlined,
} from "@ant-design/icons-vue";
import { debounce } from "lodash";
import MarketCards from "./marketcards.vue";
import QS from "qs";
import { message } from "ant-design-vue";
import addComponent from "./addComponent.vue";
import appDetails from "./appDetails.vue";
import auditComponent from "./auditComponent.vue";
import { VXETable } from "vxe-table";

const { proxy } = getCurrentInstance();

let searchVal = ref(""); // 搜索框的值
let activeClassId = ref(1); //选中的类别
let activeKey = ref(); // 选中的标签
let searchFlag = ref(false); // 搜索框是否显示
let searchStr = ref(""); // 搜索字符串
const addComponentRef = ref(null);
const appDetailsRef = ref(null);
const onSearch = () => {
    console.log("搜索框的值：", searchVal.value);
    if (searchVal.value) {
        searchFlag.value = true; // 显示搜索结果
        searchStr.value = searchVal.value; // 设置搜索字符串
    } else {
        searchFlag.value = false; // 显示搜索结果
        searchStr.value = ""; // 设置搜索字符串
    }
};

const addComponentClick = () => {
    addComponentRef.value.addAPP();
};

const editComponent = (item) => {
    addComponentRef.value.editAPP(item);
};

const delComponent = async (item) => {
    if (item.status != "0") {
        message.error("只能删除未审核的应用");
        return;
    }

    const type = await VXETable.modal.confirm("您确定要删除该数据吗?");
    if (type === "confirm") {
        const params = {
            Id: item.Id,
        };
        proxy.$api.componentManageAPI
            .delAPP(QS.stringify(params))
            .then((res) => {
                console.log("getComponentsListApi", res.data.Data);

                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "删除成功",
                    status: "success",
                });
                getComponentsListApi();
            });
    }
};

const searchChange = debounce(() => {
    console.log("搜索框的值111：", searchVal.value);
    if (searchVal.value) {
        searchFlag.value = true; // 显示搜索结果
        searchStr.value = searchVal.value; // 设置搜索字符串
    } else {
        searchFlag.value = false; // 隐藏搜索结果
        searchStr.value = ""; // 清空搜索字符串
    }
}, 1000);

let tagName = ref(""); // 选中标签名称
let className = ref(""); //选中的列别
const state = reactive({
    classTypes: [],
    commonLists: [
        { name: "我常用的", id: 1, sectionId: "section1" },
        { name: "热门", id: 2, sectionId: "section2" },
        { name: "新上线", id: 3, sectionId: "section3" },
        { name: "IS", id: 4, sectionId: "section4" },
        { name: "HR", id: 5, sectionId: "section5" },
        { name: "IT", id: 6, sectionId: "section6" },
    ],
    marketLists: [
        // { name: "热门", id: 2, sectionId: "section2" },
        // { name: "新上线", id: 3, sectionId: "section3" },
        // { name: "IS", id: 4, sectionId: "section4" },
        // { name: "HR", id: 5, sectionId: "section5" },
        // { name: "IT", id: 6, sectionId: "section6" },
    ],
    allData: {},
});
let activeClass = ref(1); //选中的类型
console.log(`activeClass${activeClass.value}`);
const changeTags = (id, name) => {
    activeKey.value = id;
    tagName.value = name;
    className.value = activeClass.value;
    console.log("选中的标签ID：", id, "选中的标签名称：", name);
    searchFlag.value = true;
};

const items = ref([]); // 数据列表
const loadMore = ref("pending"); // 加载状态：pending/loading/nomore
const page = ref(1); // 当前页码
const pageSize = 15; // 每页数据量
const totalItems = 50; // 总数据量（模拟）

const loadMoreRef = ref(null); // 加载更多元素的引用

// 模拟异步加载数据
const fetchData = (pageNum, size) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            const newData = Array.from({ length: size }, (_, i) => ({
                id: pageNum * size + i + 1,
                title: `数字员工人才 ${pageNum * size + i + 1}`,
            }));
            resolve(newData);
        }, 1000); // 模拟网络延迟
    });
};
const loadMoreData = async () => {
    // eslint-disable-next-line curly
    if (loadMore.value === "nomore") return;

    try {
        loadMore.value = "loading";
        const newData = await fetchData(page.value, pageSize);
        debugger;
        if (newData.length > 0) {
            items.value = [...items.value, ...newData];
            page.value++;
        }

        if (items.value.length >= totalItems) {
            loadMore.value = "nomore";
        } else {
            loadMore.value = "pending";
        }
    } catch (error) {
        console.error("加载失败:", error);
        loadMore.value = "pending";
    }
};
//选择类型
const handleClassClick = (e) => {
    const labelMap = state.classTypes.reduce((acc, cur) => {
        acc[cur.id] = cur.name;
        return acc;
    }, {});
    activeClass.value = labelMap[e.id];
    activeClassId.value = e.id;
    activeKey.value = nameToLabelMap.value[activeClass.value][0].id;
    searchFlag.value = false;
    className.value = activeClass.value;
    tagName.value = "";
    console.log("111" + activeClass.value);
};

const handleScroll = debounce(() => {
    const scrollBottom =
        document.documentElement.scrollHeight -
        (document.documentElement.scrollTop + window.innerHeight);

    console.log("scrollBottom: ", scrollBottom);

    if (scrollBottom < 50 && loadMore.value === "pending") {
        loadMoreData();
    }
}, 2000);
// 初始化数据
const init = async () => {
    await loadMoreData();
};

const scrollToSection = (item) => {
    const { sectionId, id, name } = item;
    if (activeKey.value === id) {
        activeKey.value = 0;
        tagName.value = "";
        if (!searchVal.value && !tagName.value) {
            searchFlag.value = false;
        }
        return; // 如果当前选中的标签已经是该标签，则不执行滚动
    }
    activeKey.value = id;
    tagName.value = name;
    if (searchFlag.value) {
        return; // 如果是搜索结果，不滚动到指定区域
    }
    const element = document.getElementById(sectionId);
    if (element) {
        element.scrollIntoView({
            behavior: "smooth", // 平滑滚动
            block: "start", // 滚动到元素顶部
        });
    }
};

// 请求接口getComponentsListApi
const getComponentsListApi = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 0,
        pageSize: 10,
        searchKey: ["", "", ""],
    };
    proxy.$api.componentManageAPI
        .getComponentsList(QS.stringify(params))
        .then((res) => {
            console.log("getComponentsListApi", res.data.Data);
            if (res.data.Success) {
                state.allData = res.data.Data;
                state.classTypes = Object.entries(res.data.Data.dataTable).map(
                    ([key, value], index) => ({
                        name: key,
                        id: index + 1,
                        sectionId: `section${index + 1}`,
                        label: value.label,
                    })
                );
                activeClass.value = state.classTypes[0].name;
                console.log("nameToLabelMap", nameToLabelMap);
            }
        });
};

getComponentsListApi(); // Todo:dd
//类别与标签对应字典
const nameToLabelMap = computed(() => {
    let counter = 1;
    return state.classTypes.reduce((map, cur) => {
        map[cur.name] = cur.label.map((labelName) => ({
            name: labelName,
            id: String(counter),
            sectionId: `section${counter++}`,
        }));
        return map;
    }, {});
});

// 执行日志接口 addDigitalEmpLogs
const addDigitalEmpLogsApi = (params) => {
    proxy.$api.dashboardAPI
        .addDigitalEmpLogs(QS.stringify(params))
        .then((res) => {
            if (res.data.Success) {
                console.log("执行日志添加成功");
            } else {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
            }
        });
};

const handleClick = (item) => {
    appDetailsRef.value.showAPPDetail(item);
};

// 清理 Intersection Observer
// onUnmounted(() => {
//   if (observer) {
//     observer.disconnect();
//   }
// });
</script>

<style lang="scss" scoped>
.page-container {
    padding: 15px 20px;
    //   background: linear-gradient(to bottom, #c1ddec, #d6e9f5, #ffffff);
    height: 100%;
    border-radius: 0.8rem;

    position: relative;
}

.page-header {
    position: sticky;
    top: 0px;
    // z-index: 999;

    background-color: #f4f6f8;

    .header-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0px;
        // background-color: #f0f0f0;
        border-radius: 5px;
    }
}

.top-title {
    font-size: 24px;
    font-weight: 600;
    cursor: pointer;
}

.header-bottom {
    display: flex;
    justify-content: space-between; /* 左右两端对齐 */
    align-items: center; /* 垂直居中 */
    .header-bottom-left {
        .header-class {
            display: flex;
            justify-content: flex-start;
            //   align-items: center;
            flex-wrap: wrap;

            .bottom-item {
                display: inline-block;
                padding: 8px 16px;
                margin-right: 4px;
                margin-bottom: 10px;
                background-color: #f9f9f9;
                /* 浅灰背景 */
                border: 1px solid #d9d9d9;
                /* 去掉底边，和内容区域衔接 */
                border-radius: 0.5rem;
                /* 上边圆角，下面直角 */
                cursor: pointer;
                transition: all 0.2s ease;
            }

            .bottom-item:hover {
                background-color: #f0f0f0; /* 浅灰 hover */
                border-color: #bfbfbf; /* 边框加深 */
            }

            .bottom-item-active {
                background-color: #1677ff; /* 高亮蓝色背景 */
                color: #fff; /* 白色文字 */
                border-color: #1677ff; /* 边框跟背景一致 */
                font-weight: bold; /* 字体加粗 */
            }
            .bottom-item-active:hover {
                background-color: #4096ff; /* 比激活色更亮一点 */
                border-color: #4096ff;
            }
        }

        .header-label {
            display: flex;
            justify-content: flex-start;
            //   align-items: center;
            flex-wrap: wrap;

            .bottom-item {
                margin-right: 10px;
                padding: 5px 12px;
                background-color: #e6f4ff;
                /* 浅蓝色 */
                border-radius: 0.5rem;
                margin-bottom: 10px;
                cursor: pointer;
                display: inline-block;
                transition: all 0.2s ease;
                /* 平滑过渡 */
            }

            .bottom-item:hover {
                background-color: #bae0ff; /* 稍微深一点的蓝 */
            }

            .bottom-item-active {
                background-color: #1677ff; /* 高亮蓝色 */
                color: #fff; /* 白色文字 */
                border: 1px solid #1677ff; /* 蓝色边框 */
                font-weight: bold; /* 字体加粗 */
                box-shadow: 0 2px 6px rgba(22, 119, 255, 0.3); /* 轻微阴影 */
            }

            .bottom-item-active:hover {
                background-color: #4096ff; /* 激活色再亮一点 */
                border-color: #4096ff;
            }
        }
    }
    .header-bottom-right {
        .btn {
            padding: 6px 18px;
            font-size: 14px;
            color: #fff;
            background-color: #007bff; /* 绿色背景 */
            border: none;
            border-radius: 4px;
            cursor: pointer;
            transition: background-color 0.2s ease;
            margin-left: 10px;
        }

        .btn:hover {
            background-color: #0056b3; /* hover 更深 */
        }

        .btn:active {
            background-color: #004085; /* 点击更深 */
        }
    }
}

.page-content {
    margin-top: 10px;

    .content-title {
        font-size: 20px;
        font-weight: 600;
        cursor: pointer;

        &:hover {
            color: #1d75fa;
        }
    }

    .content-cards {
        padding: 10px 0px;

        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 20px;
        margin-top: 10px;
        cursor: pointer;

        .cards-item {
            display: flex;
            padding: 10px;
            background-color: #fff;
            border-radius: 0.5rem;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

            .item-left {
                margin-right: 10px;
                width: 56px;
                height: 56px;
                border-radius: 50%;
                overflow: hidden;
                background-color: transparent;
                margin-top: 30px;

                img {
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    object-fit: cover;
                    cursor: pointer;
                }
            }

            .item-right {
                flex: 1;
                display: flex;
                flex-direction: column; /* 垂直排列 */
                gap: 4px; /* 状态和标题的间距 */
                .__header {
                    display: flex;
                    justify-content: flex-end; /* 全部内容靠右 */
                    align-items: center;
                    gap: 6px; /* local 和 status 之间的间距 */
                    .__local {
                        font-size: 12px;
                        font-weight: normal;
                        color: #666;
                        background-color: #e6f2ff;
                        padding: 2px 6px;
                        border-radius: 4px;
                    }
                    .__status {
                        font-size: 12px;
                        font-weight: normal;
                        color: #666;
                        background-color: #e0e0e0;
                        padding: 2px 6px;
                        border-radius: 4px;
                    }
                }

                .__title {
                    display: flex; /* 左右布局 */
                    justify-content: space-between;
                    align-items: center;
                    font-size: 16px;
                    font-weight: 600;
                    color: #1e1f24;
                }

                .__content {
                    font-size: 14px;
                    color: #50525c;
                    //   超过两行省略
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .__label {
                    font-size: 12px;
                    font-weight: normal;
                    color: #666;
                    background-color: #e0e0e0; /* 稍微深一点的灰底 */
                    padding: 2px 6px;
                    border-radius: 4px;
                    align-self: flex-start; /* 状态靠右 */
                }

                .__bottom {
                    display: flex;
                    //   justify-content: space-between;
                    align-items: center;
                    margin-top: 10px;
                    color: #848691;
                    font-size: 12px;
                    text-align: center;
                    line-height: normal;

                    div {
                        margin-right: 10px;
                        vertical-align: middle;
                    }
                    .button {
                        margin-left: 4px;
                        display: inline-block;
                        padding: 4px 6px;
                        font-size: 14px;
                        font-weight: 500;
                        color: #fff;
                        background-color: #28a745; /* 蓝色背景 */
                        border: none;
                        border-radius: 6px; /* 圆角 */
                        cursor: pointer;
                        transition: background-color 0.2s ease;
                    }

                    .button:hover {
                        background-color: #218838; /* hover 时加深 */
                    }

                    .button:active {
                        background-color: #1e7e34; /* 点击时更深 */
                    }

                    .button:disabled {
                        background-color: #ccc;
                        cursor: not-allowed;
                    }
                    .button-delete {
                        margin-left: 4px;
                        display: inline-block;
                        padding: 4px 6px;
                        font-size: 14px;
                        font-weight: 500;
                        color: #fff;
                        background-color: #dc3545; /* 红色背景 */
                        border: none;
                        border-radius: 6px; /* 圆角 */
                        cursor: pointer;
                        transition: background-color 0.2s ease;
                    }

                    .button-delete:hover {
                        background-color: #c82333; /* hover 时加深 */
                    }

                    .button-delete:active {
                        background-color: #bd2130; /* 点击时更深 */
                    }

                    .button-delete:disabled {
                        background-color: #ccc;
                        cursor: not-allowed;
                    }
                }
            }
        }
    }
}

// hover卡片时给图片增加放大效果
.cards-item:hover img {
    transform: scale(1.3);
    transition: transform 0.5s ease;
}

.load-more {
    width: 100%;
    text-align: center;
    color: #b7b9c1;
}
</style>
